function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "entry-icon/list",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(8.000000, 0.000000)",
  fill: "#1B2559"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-33",
  x: 0,
  y: 0,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-35",
  x: 0,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-37",
  x: 0,
  y: 24,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-39",
  x: 0,
  y: 36,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-34",
  x: 12,
  y: 2,
  width: 44,
  height: 4,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-36",
  x: 12,
  y: 14,
  width: 44,
  height: 4,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-38",
  x: 12,
  y: 26,
  width: 44,
  height: 4,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-40",
  x: 12,
  y: 38,
  width: 44,
  height: 4,
  rx: 1
})));

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "44px",
    viewBox: "0 0 72 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "entry-icon/list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.65e6f8cb.svg";
export { ForwardRef as ReactComponent };